/**
 * Generated by `./scripts/prebuild/generate-icons-experimental.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../../contexts/EncoreContext";
import { Experimental__Icon, findClosestGlyphAvailable } from "../../";
/**
 * @deprecated The name Experimental__IconExclamationCircle is deprecated and will be archived soon. Use IconExclamationCircle instead.
 */

export function Experimental__IconExclamationCircle(props) {
  var iconList = [{
    size: 16,
    svgContent: "<path fill='none' d='M0 0h16v16H0z'/><path d='M8 0a8 8 0 100 16A8 8 0 008 0zm0 14.946c-3.83 0-6.946-3.116-6.946-6.946S4.17 1.054 8 1.054 14.946 4.17 14.946 8 11.83 14.946 8 14.946z'/><path d='M7.214 11.639c0-.216.076-.402.228-.558a.742.742 0 01.552-.234c.216 0 .402.078.558.234.156.155.234.342.234.558s-.078.4-.234.552a.773.773 0 01-.558.229.749.749 0 01-.552-.229.752.752 0 01-.228-.552zm1.188-1.716h-.804l-.312-6.072h1.416l-.3 6.072z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zm0 21C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10z'/><path d='M10.952 17.096c0-.288.101-.536.304-.744.202-.208.448-.312.736-.312s.536.104.744.312.312.456.312.744-.104.534-.312.735c-.208.203-.456.305-.744.305s-.534-.102-.736-.305a.996.996 0 01-.304-.735zm1.584-2.288h-1.072l-.416-8.096h1.887l-.399 8.096z'/><path fill='none' d='M0 0h24v24H0z'/>"
  }, {
    size: 32,
    svgContent: "<path d='M15.5 0C6.939 0 0 6.939 0 15.5S6.939 31 15.5 31C24.06 31 31 24.06 31 15.5S24.06 0 15.5 0zm0 30C7.505 30 1 23.495 1 15.5S7.505 1 15.5 1 30 7.505 30 15.5 23.495 30 15.5 30z'/><path d='M14.19 21.401c0-.359.126-.67.38-.93s.56-.39.92-.39.67.13.93.39c.261.26.391.57.391.93 0 .36-.13.667-.391.921-.26.253-.569.38-.93.38-.36 0-.667-.127-.92-.38a1.252 1.252 0 01-.38-.921zm1.979-2.859H14.83l-.52-10.12h2.359l-.5 10.12z'/><path fill='none' d='M0 0h32v32H0z'/>"
  }, {
    size: 48,
    svgContent: "<path d='M24 1C11.298 1 1 11.297 1 24c0 12.702 10.298 23 23 23 12.703 0 23-10.298 23-23C47 11.297 36.703 1 24 1zm0 44C12.421 45 3 35.579 3 24S12.42 3 24 3c11.579 0 21 9.42 21 21 0 11.579-9.42 21-21 21z'/><path d='M21.904 33.703c0-.576.203-1.072.608-1.488.405-.416.896-.624 1.472-.624s1.072.208 1.488.624.624.912.624 1.488-.208 1.067-.624 1.472c-.416.406-.912.608-1.488.608s-1.067-.203-1.472-.608a2.002 2.002 0 01-.608-1.472zm3.168-4.576h-2.144l-.832-16.192h3.776l-.8 16.192z'/>"
  }, {
    size: 64,
    svgContent: "<path d='M32 4.001c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28c0-15.465-12.536-28-28-28zM32 58C17.664 58 6 46.336 6 32S17.664 6 32 6s26 11.664 26 26-11.664 26-26 26z'/><path d='M29.636 43.984c0-.65.229-1.209.686-1.678a2.23 2.23 0 011.66-.704c.649 0 1.209.234 1.678.704s.704 1.028.704 1.678c0 .649-.235 1.203-.704 1.66a2.317 2.317 0 01-1.678.686 2.26 2.26 0 01-1.66-.686 2.26 2.26 0 01-.686-1.66zm3.572-5.16H30.79l-.938-18.261h4.258l-.902 18.261z'/>"
  }];
  var iconListRedraw = [{
    size: 16,
    svgContent: "<path d='M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z'/><path d='M7.25 9V4h1.5v5h-1.5zm0 3.026v-1.5h1.5v1.5h-1.5z'/>"
  }, {
    size: 24,
    svgContent: "<path d='M11 18v-2h2v2h-2zm0-4V6h2v8h-2z'/><path d='M12 3a9 9 0 100 18 9 9 0 000-18zM1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12z'/>"
  }];
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);
  var iconListFallback = iconList.length === 0 ? iconListRedraw : iconList;
  var closestSize = findClosestGlyphAvailable(status === encoreContextStatus.deprecated ? iconListFallback : iconListRedraw, props.iconSize || 24);

  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };

  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };

  return /*#__PURE__*/React.createElement(Experimental__Icon, Object.assign({}, props, {
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
export default Experimental__IconExclamationCircle;